//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import AttendanceStatisticModal from "./modules/AttendanceStatisticModal";
import { queryUserTreeList } from '@/api/api';
import monthSelect from '@/components/date/monthSelect';
import moment from 'moment';
import { getAction } from '@/api/manage';
export default {
  name: 'AttendanceStatistic',
  mixins: [JeecgListMixin],
  components: {
    monthSelect: monthSelect,
    AttendanceStatisticModal: AttendanceStatisticModal
  },
  data: function data() {
    return {
      pagePath: '/om/attendance/info/statistics',
      pageTitle: '考勤统计',
      peopleTreeData: [],
      // 表头
      columns: [{
        dataIndex: 'userId_userName',
        colName: 'userId',
        title: '考勤人员',
        align: 'center'
      }, {
        dataIndex: 'sumHour',
        colName: 'sumHour',
        title: '总时长',
        align: 'center'
      }, {
        dataIndex: 'avgHour',
        colName: 'avgHour',
        title: '平均时长',
        align: 'center'
      }, {
        dataIndex: 'countNumber',
        colName: 'countNumber',
        title: '打卡次数',
        align: 'center'
      }, {
        dataIndex: 'missCount',
        colName: 'missCount',
        title: '缺卡次数',
        align: 'center'
      } // {
      //   title: '操作',
      //   dataIndex: 'action',
      //   align: 'center',
      //   scopedSlots: { customRender: 'action' },
      // },
      ],
      autoLoadInit: false
    };
  },
  created: function created() {
    this.loadPeopleTree();
    var date = moment(new Date()).format('YYYY-MM'); // 最后时间为今天

    this.queryParam.quantum = date;
    this.queryParam.type = 2;
    this.loadData();
  },
  computed: {},
  methods: {
    firstTime: function firstTime() {
      var date = moment(new Date()).format('YYYY-MM'); // 最后时间为今天

      this.queryParam.quantum = date;
    },
    loadPeopleTree: function loadPeopleTree() {
      var that = this;
      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.peopleTreeData = res.result;
        }
      });
    },
    onDateAtdnDate: function onDateAtdnDate(value, dateArray) {
      this.queryParam.atdnDateStart = dateArray[0];
      this.queryParam.atdnDateEnd = dateArray[1];
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
      this.loadData();
    },
    searchQuery: function searchQuery() {
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = {};
      var date = moment(new Date()).format('YYYY-MM'); // 最后时间为今天

      this.queryParam.quantum = date;
      this.loadData(1);
    },
    handleDetail: function handleDetail(userId) {
      this.$refs.modalForm.handleDetail(userId);
    },
    loadData: function loadData(arg) {
      this.loadStatisticsList();
    },
    loadStatisticsList: function loadStatisticsList() {
      var _this = this;

      var that = this;
      that.carList = {};
      this.queryParam.type = 2;
      this.queryParam.queryStatus = 0;
      that.params = this.getQueryParams();
      getAction(this.pagePath, that.params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        }
      });
    }
  }
};